module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp3_6005.03d4540d.png";